import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { DateValue } from '@web/utils';
import { MMMM_YYYY } from '@web/common';

@Component({
  selector: 'app-date-month-with-year',
  imports: [CommonModule, DateFormatPipe],
  templateUrl: './date-month-with-year.component.html',
  styleUrls: ['./date-month-with-year.component.scss'],
})
export class DateMonthWithYearComponent {
  @Input() public date!: DateValue;

  protected readonly MMMM_YYYY = MMMM_YYYY;
}
